





















































































import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import DebounceMixin from '@/mixins/DebounceMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import {swalSuccess, swalError, swalWarning, swalConfirm} from '@/plugins/swal';
import {jobsModule, Jobs} from '@/store/modules/jobs';
import moment from 'moment';

@Component
export default class Dashboard extends mixins(
  LoadingMixin,
  SnackbarMixin,
  DebounceMixin,
) {
  @jobsModule.State('expire') expire!: Jobs | 0;
  @jobsModule.State('point') point!: Jobs | 0;
  @jobsModule.State('quizSetting') quizSetting!: any | null;

  locationItems = [];
  quizItems = [
    {
      question: 'Soal 1',
      questionOption: [
        {option: 'a'},
        {option: 'b'},
        {option: 'c'},
        {option: 'd'},
      ],
    },
    {
      question: 'Soal 2',
      questionOption: [
        {option: 'a'},
        {option: 'b'},
        {option: 'c'},
        {option: 'd'},
      ],
    },
    {
      question: 'Soal 3',
      questionOption: [
        {option: 'a'},
        {option: 'b'},
        {option: 'c'},
        {option: 'd'},
      ],
    },
    {
      question: 'Soal 4',
      questionOption: [
        {option: 'a'},
        {option: 'b'},
        {option: 'c'},
        {option: 'd'},
      ],
    },
    {
      question: 'Soal 5',
      questionOption: [
        {option: 'a'},
        {option: 'b'},
        {option: 'c'},
        {option: 'd'},
      ],
    },
    {
      question: 'Soal 6',
      questionOption: [
        {option: 'a'},
        {option: 'b'},
        {option: 'c'},
        {option: 'd'},
      ],
    },
    {
      question: 'Soal 7',
      questionOption: [
        {option: 'a'},
        {option: 'b'},
        {option: 'c'},
        {option: 'd'},
      ],
    },
    {
      question: 'Soal 8',
      questionOption: [
        {option: 'a'},
        {option: 'b'},
        {option: 'c'},
        {option: 'd'},
      ],
    },
  ];
  list_education_level = ['SMP/SMK', 'Diploma', 'Sarjana', 'Magister'];
  category = '';
  location = null;
  jobtype = null;
  isLoading = false;
  page = 1;
  meta: any = null;
  form: any = [];
  radioGroup = [];
  answareUser: any = [];
  items = [
    {
      src:
        'https://www.dictio.id/uploads/db3342/original/3X/6/b/6b3194ebea481506686ea44c0c76d00b89542529.jpeg',
    },
  ];
  currentPage = 1;
  maxPerPage = 3;
  showReadMore = true;
  timeoutQuiz: any = null;
  orders = 10;
  search = null;
  education = null;
  isFinish = false;
  isLoadingTime = true;
  progressCount = 0;
  statusQuiz = 0;
  timerQuiz: any = null;
  expireTime = 100;
  async mounted() {
    if (!this.point) {
      this.$router.push('/quiz/introduction');
    } else {
      this.expireTime = Number(this.expire);
      await this.facthData();
    }
  }
  nextQuestion() {
    this.page = this.page + 1;
    this.progressCount = (100 * this.page) / this.meta.total_page;
    // this.facthData();
  }
  goToQuestion(idx: number) {
    this.page = idx;
    // this.facthData();
  }
  backQuestion() {
    this.page = this.page - 1;
    this.progressCount = (100 * this.page) / this.meta.total_page;
    // this.radioGroup.push();
    // this.facthData();
  }
  perviousQuestion() {
    this.page = this.page - 1;
    // this.facthData();
  }
  convertSecond(countDown: any) {
    const h = Math.floor(countDown / 3600);
    const m = Math.floor((countDown % 3600) / 60);
    const s = Math.floor((countDown % 3600) % 60);

    const hDisplay = h > 0 ? h + ' Jam ' : '';
    const mDisplay = m > 0 ? m + ' Menit ' : '';
    const sDisplay = s > 0 ? s + ' Detik' : '';
    return hDisplay + mDisplay + sDisplay;
  }
  async onSubmit() {
    try {
      this.isFinish = true;
      this.answareUser.push(this.radioGroup);
      this.startLoading('saving');
      const res = await this.$store.dispatch('jobs/sendQuiz', this.answareUser);
      if (res.status === 200) {
        this.finishLoading('saving');
        const form = {
          point_quiz: res.data.data,
          status: res.data.data >= this.point ? 1 : 0,
          quiz_setting_id: this.quizSetting?.id,
          quiz_total: this.quizSetting?.id,
          quiz_minimal_corect: this.quizSetting?.min_correct_answer,
          total_question: this.quizSetting?.total_question,
          time_limit: this.quizSetting?.time_limit,
          tile_end: new Date(),
          time_end_quiz: this.expireTime,
        };
        await this.$store.dispatch('jobs/updateQuiz', form);
        if (res.data.data >= this.point) {
          swalSuccess.fire({
            title: 'Selamat!',
            text: res.data.message,
          });
          setTimeout(() => this.$router.push('/jobs'), 1000);
          this.finishLoading('saving');
        } else {
          swalError.fire({
            title: 'Maaf!',
            text: `Anda belum lulus pre test. Silahkan coba kembali 6 bulan ke depan. Hati-hati Penipuan yang mengatasnamakan Rekrutmen Yogya Group! Semua proses perekrutan TIDAK DIPUNGUT Biaya (Gratis)`,
          });
          this.$router.push('/');
        }
      }
    } catch (e) {
      swalError.fire({
        title: 'Maaf!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }
  created() {
    this.countDownTimer();
  }
  async facthData() {
    try {
      this.isLoading = true;
      this.startLoading('detail');
      const params: any = {};
      params.page_size = 1;
      params.page = this.page;
      const res = await this.$store.dispatch('jobs/getQuiz', params);
      this.finishLoading('detail');
      if (res.status === 400 && res.data.data.status === 1) {
        swalError.fire({
          title: 'Failed!',
          text: `Mohon maaf Anda Sudah melakukan test`,
        });
        this.$router.push('/');
      } else if (
        res.status === 400 &&
        res.data.data.status === 0 &&
        moment(res.data.data.createdAt, 'YYYY-MM-DD')
          .add(192, 'days')
          .diff(moment(res.data.data.createdAt, 'YYYY-MM-DD'), 'days') > 1
      ) {
        swalError.fire({
          title: 'Failed!',
          text: `Mohon maaf Anda tidak lolos dalam Pre-Test. Silahkan melakukan Pre-Test kembali ${moment(
            res.data.data.createdAt,
            'YYYY-MM-DD',
          )
            .add(192, 'days')
            .diff(
              moment(res.data.data.createdAt, 'YYYY-MM-DD'),
              'days',
            )} hari kedepan.`,
        });
        this.$router.push('/');
      } else {
        this.quizItems = res.data.data;
        this.page = res.data.pagination.page;
        this.meta = {
          total_page: this.quizItems.length, // Total halaman berdasarkan jumlah quizItems
        };
        this.isLoading = false;
      }
    } catch (e) {
      this.isLoading = false;
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }
  countDownTimer() {
    if (this.expire) {
      if (this.expireTime > 0) {
        this.timeoutQuiz = setTimeout(() => {
          this.expireTime -= 1;
          this.countDownTimer();
        }, 1000);
      } else {
        this.onSubmit();
      }
    }
  }
  beforeDestroy() {
    clearTimeout(this.timeoutQuiz);
  }
  beforeRouteLeave(to: any, from: any, next: any) {
    if (!this.isFinish) {
      swalConfirm
        .fire({
          title: 'Apakah anda yakin?',
          text: 'Apakah anda yakin ingin mengakhiri Quiz ini?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya, akhiri!',
          cancelButtonText: 'Tidak',
        })
        .then(result => {
          if (result.isConfirmed) {
            next();
          } else {
            next(false);
          }
        });
    } else {
      next();
    }
  }
}
